import React from "react";
import {
  // Breadcrumb,
  DefaultButton,
  PrimaryButton,
  Stack,
  TextField,
} from "@fluentui/react";
import { Formik } from "formik";
import { Loading } from "../../../services/Loading";
import {
  addOrUpdateSLAMatrixConfig,
  getSLAMatrixConfig,
} from "../../../services/sla-matrix/SlaMatrixService";
import { ICustomers, ISLAMatrix } from "../../../vm";
import { childrenGap } from "../../common/Constants";
import { ToastContext } from "../../common/ToastProvider";
import { useHistory, useParams } from "react-router-dom";
// import { getAllCustomers } from "../../../services/customers/CustomerService";
import { parseJwt } from "../../../services/UtilService";
import CustomDrawer from "../../common/CustomDrawer";
import SlaDeviation from "./SlaDeviation";

export interface SlaMatrixProps { }

const SlaMatrix: React.FC<SlaMatrixProps> = () => {
  // custom hooks
  const { showToast } = React.useContext(ToastContext);
  const params: any = useParams();
  const history = useHistory();
  const tokenData = parseJwt();

  // state
  const [state, setState] = React.useState({
    isLoading: false,
    slaMatrix: {},
    isEdit: false,
    customer: {
      name: "",
    },
    manageDeviationDialog: {
      isOpen: false,
      customerId: params.customerId
    }
  } as {
    isLoading: boolean;
    slaMatrix: ISLAMatrix;
    isEdit: boolean;
    customer: ICustomers;
    manageDeviationDialog: {
      isOpen: boolean,
      customerId: string
    }
  });

  // hooks
  React.useEffect(() => {
    const asyncFunc = async () => {
      await getSlaMatrix();
    };
    asyncFunc();
  }, []);

  const getSlaMatrix = async () => {
    setState({ ...state, isLoading: true });
    let result = await getSLAMatrixConfig(params.customerId);
    if (result?.success) {
      setState({
        ...state,
        slaMatrix: result.data || { humidity: {}, temperature: {} },
        isLoading: false,
      });
      // getACustomer(result.data);
    } else {
      setState({ ...state, isLoading: false });
      showToast(result?.message || "Error while getting sla matrixes", "error");
    }
  };

  // const getACustomer = async (slaMatrix: ISLAMatrix) => {
  //   setState({ ...state, isLoading: true });
  //   let result = await getAllCustomers({ customerId: params.customerId });
  //   if (result?.success && result.data.length > 0) {
  //     setState({
  //       ...state,
  //       slaMatrix: slaMatrix || { humidity: {}, temperature: {} },
  //       customer: result.data[0],
  //       isLoading: false,
  //     });
  //   } else {
  //     setState({ ...state, isLoading: false });
  //     showToast(
  //       result.message || "Error while getting customer details",
  //       "error"
  //     );
  //   }
  // };

  const handleDeviationDialogOpenClose = (isOpen: boolean) => {
    setState({
      ...state,
      manageDeviationDialog: {
        ...state.manageDeviationDialog,
        isOpen: isOpen
      },
    });
  };

  return (
    <React.Fragment>
      {state.isLoading && <Loading />}
      {/* <Stack>
        <Breadcrumb
          items={[
            {
              text: state.customer.name,
              key: "name",
              onClick: () => {
                history.push(`/customers/${state.customer._id}`);
              },
            },
            {
              text: "SLA Matrixes Config",
              key: "sla-matrixes-config",
              isCurrentItem: true,
            },
          ]}
        />
      </Stack> */}
      {/* <br /> */}
      <div
        // style={{
        //   width: "40%",
        //   // margin: "auto",
        // }}
        className="custom-sm-table pt-16"
      >
        {/* <Stack tokens={childrenGap}>
          <Stack.Item>
            <Stack horizontal wrap tokens={childrenGap} horizontalAlign="end">
              {!state.isEdit && (
                <Stack.Item>
                  <DefaultButton
                    text="Edit"
                    onClick={() => setState({ ...state, isEdit: true })}
                  />
                </Stack.Item>
              )}
            </Stack>
          </Stack.Item>
          <Stack.Item> */}
        <React.Fragment>
          <Formik
            enableReinitialize
            initialValues={state.slaMatrix}
            onSubmit={async (values: ISLAMatrix, { setSubmitting }) => {
              let data = { ...values };
              data.customerId = params.customerId;
              setState({ ...state, isLoading: true });
              let result = await addOrUpdateSLAMatrixConfig(data);
              if (result?.success) {
                setState({
                  ...state,
                  slaMatrix: result.data,
                  isLoading: false,
                  isEdit: false,
                });
                showToast(
                  "SLA Matrixes config updated successfully",
                  "success"
                );
              } else {
                setState({ ...state, isLoading: false });
                showToast(
                  result?.message || "Error while updating sla matrixes config",
                  "error"
                );
              }
              setSubmitting(false);
            }}
          >
            {({ handleChange, handleBlur, handleSubmit, values }) => (
              <form onSubmit={handleSubmit}>
                <Stack tokens={childrenGap}>
                  <Stack.Item>
                    <Stack horizontal wrap tokens={childrenGap}>
                      {state.isEdit ? (
                        <>
                          <Stack.Item>
                            <PrimaryButton type="submit" text="Save" />
                          </Stack.Item>
                          <Stack.Item>
                            <DefaultButton
                              onClick={() =>
                                setState({ ...state, isEdit: false })
                              }
                              text="Cancel"
                              className="borderless-btn"
                            />
                          </Stack.Item>
                        </>
                      ) : ![3, 4].includes(tokenData.role) && (
                        // ) : tokenData.isAdmin && [0, 2, 5].includes(tokenData.role) && (
                        <Stack.Item>
                          <PrimaryButton
                            text="Edit"
                            onClick={() => setState({ ...state, isEdit: true })}
                          />
                        </Stack.Item>
                      )}
                      <Stack.Item>
                        <PrimaryButton
                          text="View SLA Deviation"
                          onClick={() => handleDeviationDialogOpenClose(true)}
                        />
                      </Stack.Item>
                    </Stack>
                  </Stack.Item>
                  <Stack.Item>
                    <div
                      className="office-table borderless-table"
                      style={{ overflow: "hidden" }}
                    >
                      <table className="ms-Table">
                        <thead className="html-table-thead">
                          <tr
                            style={{
                              height: 44,
                              fontSize: 14,
                            }}
                          >
                            <th>Description of Service</th>
                            <th>As per SLA</th>
                          </tr>
                        </thead>
                        <tbody style={{ color: "#383737" }}>
                          <tr
                            style={{
                              height: 44,
                              backgroundColor: "#fdfdfd",
                            }}
                          >
                            <td width={140} align="center">
                              Power Uptime
                            </td>
                            {state.isEdit ? (
                              <td width={200}>
                                <TextField
                                  name="powerUptime"
                                  type="number"
                                  value={String(values?.powerUptime)}
                                  suffix="%"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                />
                              </td>
                            ) : (
                              <td align="center" width={200}>
                                {values?.powerUptime
                                  ? values.powerUptime + "%"
                                  : "0%"}
                              </td>
                            )}
                          </tr>
                          <tr
                            style={{
                              height: 44,
                              backgroundColor: "#f3f3f3",
                            }}
                          >
                            <td width={140} align="center">
                              AC Uptime
                            </td>
                            {state.isEdit ? (
                              <td>
                                <TextField
                                  name="acUptime"
                                  type="number"
                                  value={String(values?.acUptime)}
                                  suffix="%"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                />
                              </td>
                            ) : (
                              <td align="center">
                                {values?.acUptime
                                  ? values.acUptime + "%"
                                  : "0%"}
                              </td>
                            )}
                          </tr>
                          <tr
                            style={{
                              height: 44,
                              backgroundColor: "#fdfdfd",
                            }}
                          >
                            <td width={140} align="center">
                              Temperature
                            </td>
                            {state.isEdit ? (
                              <td>
                                <Stack horizontal tokens={childrenGap}>
                                  <Stack.Item grow>
                                    <TextField
                                      name="temperature.min"
                                      type="number"
                                      value={String(values?.temperature?.min)}
                                      suffix="℃"
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                    />
                                  </Stack.Item>
                                  <Stack.Item> to </Stack.Item>
                                  <Stack.Item grow>
                                    <TextField
                                      name="temperature.max"
                                      type="number"
                                      value={String(values?.temperature?.max)}
                                      suffix="℃"
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                    />
                                  </Stack.Item>
                                </Stack>
                              </td>
                            ) : (
                              <td align="center">
                                {values?.temperature?.min
                                  ? values.temperature.min + "℃  to  "
                                  : "0℃ to "}
                                {values?.temperature?.max
                                  ? values?.temperature?.max + "℃"
                                  : "0℃"}
                              </td>
                            )}
                          </tr>
                          <tr
                            style={{
                              height: 44,
                              backgroundColor: "#f3f3f3",
                            }}
                          >
                            <td width={140} align="center">
                              Humidity
                            </td>
                            {state.isEdit ? (
                              <td>
                                <Stack horizontal tokens={childrenGap}>
                                  <Stack.Item grow>
                                    <TextField
                                      name="humidity.min"
                                      type="number"
                                      value={String(values?.humidity?.min)}
                                      suffix="%"
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                    />
                                  </Stack.Item>
                                  <Stack.Item>to</Stack.Item>
                                  <Stack.Item grow>
                                    <TextField
                                      name="humidity.max"
                                      type="number"
                                      value={String(values?.humidity?.max)}
                                      suffix="%"
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                    />
                                  </Stack.Item>
                                </Stack>
                              </td>
                            ) : (
                              <td align="center">
                                {values?.humidity?.min
                                  ? values.humidity.min + "%  to  "
                                  : "0% to "}
                                {values?.humidity?.max
                                  ? values.humidity.max + "%"
                                  : "0%"}
                              </td>
                            )}
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </Stack.Item>
                  {/* {state.isEdit && (
                    <Stack.Item>
                      <Stack
                        horizontal
                        wrap
                        tokens={childrenGap}
                        horizontalAlign="end"
                      >
                        <Stack.Item>
                          <DefaultButton
                            onClick={() =>
                              setState({ ...state, isEdit: false })
                            }
                            text="Cancel"
                          />
                        </Stack.Item>
                        <Stack.Item>
                          <PrimaryButton type="submit" text="Save" />
                        </Stack.Item>
                      </Stack>
                    </Stack.Item>
                  )} */}
                </Stack>
              </form>
            )}
          </Formik>
        </React.Fragment>
        {/* </Stack.Item>
        </Stack> */}
      </div>
      {state.manageDeviationDialog.isOpen && (
        <React.Fragment>
          <CustomDrawer
            title={"View SLA Deviation"}
            handelOpen={true}
            onClose={() => handleDeviationDialogOpenClose(false)}
          >
            <SlaDeviation customerId={state.manageDeviationDialog.customerId} />
          </CustomDrawer>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default SlaMatrix;
